import React, { useEffect, useState } from "react";
import AccountSettings from "./AccountSettings";
import WorskpacesSettings from "./WorskpacesSettings";
import { useLocation } from "react-router-dom";
import { useRedirect } from "../../hooks/useRedirect";

const Settings = () => {
  const [pageIndex, setPageIndex] = useState<number>(1);
  const location = useLocation();
  const redirect = useRedirect();

  useEffect(() => {
    if (!location.hash) {
      redirect("#account");
    } else if (location.hash === "#account") {
      setPageIndex(1);
    } else if (location.hash === "#workspace") {
      setPageIndex(2);
    }
  }, [location.hash, redirect]);

  return (
    <>
      <h1 className="text-[#0F0C18] text-[28px] font-medium leading-9 tracking-tight">Settings</h1>
      <p className="text-[#9392A2] text-sm font-medium mt-2 tracking-tight">All your preferences of accounts and workspaces.</p>
      <div className="mt-6 mb-4">
        <div className="flex items-center gap-[21px]">
          <p onClick={() => {
            setPageIndex(1)
            redirect("#account")
          }} className={`${pageIndex === 1 ? "text-[#0F0C18] border-b-2" : "text-[#9392A2] pb-[10px]"} border-[#0F0C18] text-sm font-medium pb-2 cursor-pointer`}>Accounts</p>
          <p onClick={() => {
            setPageIndex(2)
            redirect("#workspace")
          }} className={`${pageIndex === 2 ? "text-[#0F0C18] border-b-2" : "text-[#9392A2] pb-[10px]"} border-[#0F0C18] text-sm font-medium pb-2 cursor-pointer`}>Worskpaces</p>
        </div>
        <div className="w-full h-[1px] bg-[#CDCCD7] -mt-[1.5px]" />
      </div>
      {
        pageIndex === 1 &&
        <AccountSettings />
      }
      {
        pageIndex === 2 &&
        <WorskpacesSettings />
      }
    </>
  );
};

export default Settings;